export const DEFAULT_NOTES_PLACEHOLDER = `請輸入以下資訊，資訊越詳細配對成功機率越高！\n1. 病患治療狀況，如做過XXX治療項目，並在進行XXX療程。\n2. 病患身體狀態，如意識清楚、可講話，需協助攙扶如廁。`;
export const HOME_CARE_NOTES_PLACEHOLDER = `${DEFAULT_NOTES_PLACEHOLDER}\n3. 建議詳述照顧地點附近地標或路名，增加配對機率。`;
